import { observer } from 'mobx-react-lite';
import GrabIconButton from './GrabIconButton';
import { GrabIconButtonProps, GrabIconButtonValueProps } from './types';

export type { GrabIconButtonProps, GrabIconButtonValueProps };
export default observer(GrabIconButton); // MANUAL OVERRIDE;
